import NIGHT_COLORS from 'eds-settings/themes/night/colors.json';
import { genTheme } from '../_internal/utils';

export default genTheme(null, NIGHT_COLORS);
